<template>
  <b-card v-if="!!option" id="page-supports-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }} {{ $t("pages.supports.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('title'))" label-for="title">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('title'))"
                  rules="required"
                >
                  <b-form-input
                    id="title"
                    v-model="ticketSupport.title"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('title'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('description'))"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="ticketSupport.description"
                  :placeholder="$t(label('description'))"
                  :disabled="!isSaveMode"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('idCatStatus'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('idCatStatus'))"
                  label-for="idCatStatus"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="ticketSupport.idCatStatus"
                    input-id="idCatStatus"
                    :options="listStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('idCatStatus'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.typesSubs.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('idCatPriority'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('idCatPriority'))"
                  label-for="idCatPriority"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="ticketSupport.idCatPriority"
                    input-id="idCatPriority"
                    :options="listPriority"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('idCatPriority'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.typesSubs.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('idEmployeeAssignedTo'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('idEmployeeAssignedTo'))"
                  label-for="idEmployeeAssignedTo"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="ticketSupport.idEmployeeAssignedTo"
                    input-id="idEmployeeAssignedTo"
                    :options="allEmployees"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('idEmployeeAssignedTo'))"
                    :disabled="!isSaveMode"
                    :taggable="false"
                    :reduce="(option) => option.idEmployee"
                    @search="searchClientsAll"
                    :filterable="false"
                    @open="onOpenClients"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageEmployees"
                        ref="loadClients"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex align-items-center justify-content-center"
            >
              <b-form-group
                :label="$t(label('documents'))"
                label-for="inputFilePhoto"
              >
                <b-media class="body-style">
                  <div v-if="ticketSupport.documents.length === 0">
                    <input
                      id="inputFilePhoto"
                      ref="fileInputPhoto"
                      name="inputFilePhoto"
                      type="file"
                      class="hidden"
                      accept=".png,.peg,.jpg,.jpeg"
                      @change="onFileChange($event, 'documents')"
                      multiple
                    />
                    <div
                      class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                      accept=".png,.peg,.jpg,.jpeg"
                      @drop="handleDrop($event, 'documents')"
                      @dragover="handleDragover"
                      @dragenter="handleDragover"
                      @click="$refs.fileInputPhoto.click()"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        size="20"
                        svg-classes="h-16 w-16 stroke-current text-grey"
                      />
                      <span
                        style="margin-left: 5px"
                        @click.stop="$refs.fileInputPhoto.click()"
                        >{{ $t(label("documents")) }}
                      </span>
                    </div>
                  </div>
                  <template v-if="ticketSupport.documents.length > 0" #aside>
                    <div class="d-flex flex-wrap">
                      <img
                        v-for="(doc, index) in ticketSupport.documents"
                        :key="index"
                        :src="doc.urlFile"
                        class="img-avatar border-dashed mr-50 mb-50"
                      />
                    </div>
                  </template>
                </b-media>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BForm,
  BFormTextarea,
  BFormInvalidFeedback,
  BMedia,
  BFormFile,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, integer } from "@validations";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import {
  getTicketSupport,
  createOrEditTicketSupport,
  allEmployeesByCompany,
  postFile,
} from "@/@core/api/request";
import { getCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

const ticketSupport = {
  idTicketsSupport: null,
  guid: null,
  idCompany: null,
  guidCompany: null,
  title: null,
  description: null,
  idCatStatus: null,
  nameStatus: null,
  colorStatus: null,
  idCatPriority: null,
  namePriority: null,
  colorPriority: null,
  idEmployeeAssignedTo: null,
  nameEmployee: null,
  dateCreated: null,
  documents: [],
};

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    vSelect,
    BFormTextarea,
    BMedia,
    BFormFile,
  },

  directives: {
    Ripple,
  },

  data: () => ({
    isSaveMode: true,
    required,
    integer,
    companyGuid: null,
    ticketSupport: Object.assign(ticketSupport),
    option: "",
    typesSubsSelected: null,
    coinTypsSelected: null,
    listStatus: [],
    listPriority: [],
    itemsPage: 1,
    itemsRows: 999,
    allEmployees: [],
    loadingEmployees: false,
    currentPageEmployees: 1,
    perPageEmployees: 20,
    totalPagesEmployees: null,
    hasNextPageEmployees: true,
  }),

  created() {
    localize("es");
  },

  computed: {},

  mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();
    this.loadCatData();
    this.loadEmployeesByCompanie();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
    },
  },
  methods: {
    label(field) {
      return `pages.supports.form.label.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    chargeParams(key) {
      let arrParams = [];

      arrParams.push(`itemsPage,${this.itemsPage}`);

      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "ticketSupportStatus":
          arrParams.push("guidCatalog, 0c98881d-eccb-44ac-876e-0d12f2ea9147");
          break;
        case "ticketSupportPriority":
          arrParams.push("guidCatalog, bdd918b2-a609-4777-b013-3109e87f5e1e");
          break;
      }

      return getParams(arrParams);
    },

    initialize() {
      this.option = this.$route.params.option;
      console.log("Options", this.option);

      if (this.option === undefined) {
        router.push({ name: "supports" }).catch(() => {});
      }
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        // option 2 to show, option 3 to edit
        case 2:
        case 3:
          if (this.$route.params.idSupplier === undefined) {
            router.push({ name: "supports" }).catch(() => {});
          }
          this.isSaveMode = this.option === 2 ? false : true;
          this.getTicketSupport(this.$route.params.idSupplier);
          break;
      }
    },

    getTicketSupport(idSupplier) {
      showLoading();
      getTicketSupport(idSupplier)
        .then((resp) => {
          const response = _.get(resp, "data");
          this.ticketSupport = Object.assign(this.ticketSupport, {
            idTicketsSupport: response.idTicketsSupport || null,
            guid: response.guid || null,
            idCompany: response.idCompany || null,
            guidCompany: response.guidCompany || null,
            title: response.title || null,
            description: response.description || null,
            idCatStatus: response.idCatStatus || null,
            nameStatus: response.nameStatus || null,
            colorStatus: response.colorStatus || null,
            idCatPriority: response.idCatPriority || null,
            namePriority: response.namePriority || null,
            colorPriority: response.colorPriority || null,
            idEmployeeAssignedTo: response.idEmployeeAssignedTo || null,
            nameEmployee: response.nameEmployee || null,
            documents: response.documents || [],
          });
          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
        });
    },

    async loadCatData() {
      showLoading();
      try {
        const paramTypeSub = this.chargeParams("ticketSupportStatus");
        const paramCoinTyps = this.chargeParams("ticketSupportPriority");
        const [resultTypeSubs, resultCoinTyps] = await Promise.all([
          getCatalog(paramTypeSub),
          getCatalog(paramCoinTyps),
        ]);
        stopLoading();
        this.listStatus = _.get(resultTypeSubs, "data.listOfItems.items");
        this.listPriority = _.get(resultCoinTyps, "data.listOfItems.items");
      } catch (error) {
        console.log("error", error);
        stopLoading();
        this.alertToast("danger", `Alerta codigo`, error.message);
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          const body = {
            idTicketsSupport: this.ticketSupport?.idTicketsSupport,
            guidCompany: this.companyGuid,
            title: this.ticketSupport?.title,
            description: this.ticketSupport?.description,
            idCatStatus: this.ticketSupport?.idCatStatus,
            idCatPriority: this.ticketSupport?.idCatPriority,
            idEmployeeAssignedTo: this.ticketSupport?.idEmployeeAssignedTo,
            documents: this.ticketSupport?.documents,
          };
          showLoading();
          createOrEditTicketSupport(body, this.ticketSupport?.idTicketsSupport)
            .then((response) => {
              console.log(response);
              stopLoading();
              this.alertToast(
                "success",
                `Alerta`,
                `${
                  this.option != 3 ? "Registro exitoso" : "Registro actualizado"
                }`,
              );
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", "Alerta error", error.message);
            });
        }
      });
    },

    onCancel() {
      Object.assign(this.ticketSupport, {
        idTicketsSupport: null,
        guid: null,
        idCompany: null,
        guidCompany: null,
        title: null,
        description: null,
        idCatStatus: null,
        nameStatus: null,
        colorStatus: null,
        idCatPriority: null,
        namePriority: null,
        colorPriority: null,
        idEmployeeAssignedTo: null,
        nameEmployee: null,
        dateCreated: null,
        documents: [],
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    async onOpenClients() {
      if (this.hasNextPageEmployees) {
        await this.$nextTick();
        this.observerClients.observe(this.$refs.loadClients);
      }
    },

    async searchClientsAll(value) {
      this.searchClients = value;
      this.allEmployees = [];
      this.currentPageEmployees = 1;
      this.hasNextPageEmployees = true;
      this.loadEmployeesByCompanie();
    },

    chargeParamsEmployees() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageEmployees}`);

      arrParams.push(`rows,${this.perPageEmployees}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchClients != null)
        arrParams.push(`name,${this.searchClients}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },

    async loadEmployeesByCompanie() {
      if (this.loadingEmployees || !this.hasNextPageEmployees) return;

      this.loadingEmployees = true;
      const param = this.chargeParamsEmployees();
      await allEmployeesByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.allEmployees = [...this.allEmployees, ...data?.items];
            this.currentPageEmployees = data?.currentPage;
            this.totalPagesEmployees = data?.totalPages || 0;
            this.hasNextPageEmployees =
              this.currentPageEmployees < this.totalPagesEmployees;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageEmployees = false;
        })
        .finally(() => {
          this.loadingEmployees = false;
        });
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },
    onTransFile(files, accept, multiple, field) {
      // if (multiple) return;
      let arrayDocuments = this.ticketSupport.documents;
      // this.loadingPhoto = true
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            let dt = {
              urlFile: resp.data,
            };
            arrayDocuments.push(dt);
            this.ticketSupport[field] = arrayDocuments;
          })
          .catch(console.error)
          .finally(() => {
            stopLoading();
          });
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../../../public/loader.css";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
